/* istanbul ignore file */
import React from 'react';
import classnames from 'classnames';
import ButtonGroup from '@mui/material/ButtonGroup';
import useViewModeToggle from './useViewModeToggle';
import { useUiTheme } from 'framework/uiTheme';

interface ViewModeToggleProps {
  icons: Dictionary<React.ReactNode>;
  modes: Dictionary<string>;
  onModeChange?: (mode: any) => void;
  cacheName: string;
  defaultMode: string;
  className?: string;
  initialMode?: string;
}

const ViewModeToggle = ({ icons, modes, className, ...props }: ViewModeToggleProps) => {
  const { activeMode, updateActiveMode } = useViewModeToggle(props);
  const { Button } = useUiTheme();

  return (
    <ButtonGroup
      className={classnames('view-mode-toggle', className)}
      sx={theme => ({
        alignItems: 'center',
        '& .MuiButtonBase-root': {
          color: 'text.primary',
          '&.active': {
            pointerEvents: 'none',
            backgroundColor: 'common.menuItemActive',
            color: 'primary.main',
          },
        },
        [theme.breakpoints.down('sm')]: { marginTop: '15px' },
      })}
    >
      {Object.entries(modes).map(([key, value]) => (
        <Button
          key={key}
          color="primary"
          className={activeMode === value ? 'active' : ''}
          onClick={(e: any) => {
            e.target.blur();

            updateActiveMode(value);
          }}
          startIcon={icons[value]}
        >
          {value}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ViewModeToggle;
